import http from "../utils/http";

export const getDocumentReleaseHistory = async (
  params: string
): Promise<Response> => {
  return await http.get(`/api/document-release-histories${params}`);
};
